export function getGigAssets(gig, gigsAsyncAssets = {}) {
    let gigAssets = (gig.assets && gig.assets.length > 0) ? gig.assets : [];
    const mainAsset = {
        img_medium: gig.img_medium,
        image_data: gig.image_data,
        asset_type: 'image'
    };

    if (gig.video_url) {
        mainAsset.asset_type = 'video';
        mainAsset.video_stream_url = gig.video_stream_url;
        mainAsset.video_thumb = gig.video_thumb;
        mainAsset.video_thumb_lrg = gig.video_thumb_lrg;
        mainAsset.video_url = gig.video_url;
        mainAsset.seller_id = gig.seller_id;
    }

    gigAssets.shift();
    gigAssets.unshift(mainAsset);

    // We still don't have slide assets.
    // maybe we got them from a separate ajax call
    if (gigAssets.length <= 1 && gigsAsyncAssets[gig.gig_id]) {
        gigAssets = gigAssets.concat(gigsAsyncAssets[gig.gig_id].slice(1));
    }

    return gigAssets;
}



// WEBPACK FOOTER //
// ./src/utils/getGigAssets/index.js